import React, { useMemo } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import store from './store';
import { AuthProvider } from './component/auth/AuthContext';
import { UploadProvider } from './component/main/history/UploadContext';
import { ThemeProvider, useTheme } from './component/theme/ThemeContext';
import Navigator from './component/ui/Navigator/Navigator';
import ErrorBoundary from './pages/Error/ErrorBoundary';
import { buildAntdTheme } from './styles/antdTheme';

// antd cannot read the CSS custom properties that drive the SCSS layer, so the
// palette has to be rebuilt and handed back to ConfigProvider on every theme
// flip. This has to be its own component because useTheme() only works below
// ThemeProvider, and App itself renders the provider.
function ThemedConfigProvider({ children }) {
  const { theme } = useTheme();
  const antdTheme = useMemo(() => buildAntdTheme(theme), [theme]);

  return <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>;
}

function App() {
  return (
    <ThemeProvider>
      <Provider store={store}>
        <ThemedConfigProvider>
          <AuthProvider>
            <UploadProvider>
              <Router>
                <ErrorBoundary>
                  <Navigator />
                </ErrorBoundary>
              </Router>
            </UploadProvider>
          </AuthProvider>
        </ThemedConfigProvider>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
